import {
  mdiCalendarRange,
  mdiCheck,
  mdiChevronDown,
  mdiChevronLeft,
  mdiChevronRight,
  mdiChevronUp,
  mdiClose,
  mdiCog,
  mdiCursorMove,
  mdiDotsHorizontal,
  mdiDotsVertical,
  mdiDownload,
  mdiEmail,
  mdiExclamation,
  mdiHelpCircleOutline,
  mdiImageOutline,
  mdiIncognito,
  mdiInformationVariant,
  mdiMagnify,
  mdiMapMarkerOutline,
  mdiMinus,
  mdiOpenInNew,
  mdiPencil,
  mdiPlus,
  mdiRefresh,
  mdiShareVariantOutline,
  mdiTune,
  mdiUpload
} from "@mdi/js";
export const externalLinkIcon = mdiOpenInNew;
export const searchIcon = mdiMagnify;
export const nextIcon = mdiChevronRight;
export const backIcon = mdiChevronLeft;
export const createIcon = mdiPlus;
export const checkIcon = mdiCheck;
export const warningIcon = mdiExclamation;
export const editIcon = mdiPencil;
export const destroyIcon = mdiClose;
export const optionsIcon = mdiDotsVertical;
export const helpIcon = mdiHelpCircleOutline;
export const closeIcon = mdiClose;
export const cancelIcon = mdiClose;
export const infoIcon = mdiInformationVariant;
export const moreIcon = mdiDotsHorizontal;
export const refreshIcon = mdiRefresh;
export const locationIcon = mdiMapMarkerOutline;
export const dateIcon = mdiCalendarRange;
export const submitIcon = mdiCheck;
export const anonymousIcon = mdiIncognito;
export const privacyIcon = mdiIncognito;
export const removeIcon = mdiMinus;
export const downloadIcon = mdiDownload;
export const resetIcon = mdiClose;
export const uploadIcon = mdiUpload;
export const moveIcon = mdiCursorMove;
export const declineIcon = mdiClose;
export const acceptIcon = mdiCheck;
export const emailIcon = mdiEmail;
export const saveIcon = mdiCheck;
export const settingsIcon = mdiCog;
export const upIcon = mdiChevronUp;
export const downIcon = mdiChevronDown;
export const manageIcon = mdiTune;
export const imageIcon = mdiImageOutline;
export const shareIcon = mdiShareVariantOutline;
